import React from 'react';
import { useTranslation } from 'react-i18next';

const RequestSection = ({ tTitle, children }) => {
  const { t } = useTranslation();

  return (
    <section className="request-section">
      {tTitle && <div className="request-section-header">{t(tTitle)}</div>}
      <div className="request-section-body">{children}</div>
    </section>
  );
};

export default RequestSection;
